<template>
  <aside class="cart-summary w-100">

    <div class="subtotal w-100 flex-between flex">
      <p class="title">Subtotal</p>
      <p class="price">${{ getFormatAmount(cart.subTotalAmount) }} NZD</p>
    </div>

    <p class="note">Shipping calculated at checkout.</p>

    <button
      class="checkout"
      v-if="show_proceed && cart.subTotalAmount"
      @click="goToCheckout" :disabled="disableButton"
    >
      Checkout
    </button>

    <!--<div class="prices">
      <p>
        Subtotal
        <span>${{ getFormatAmount(cart.subTotalAmount) }}</span>
      </p>

      <template v-if="!show_subtotal_only">
        <p v-if="cart.hasFreightCalculations">
          Shipping
          <span>${{ getFormatAmount(cart.shippingAmount) }}</span>
        </p>
        <p>
          GST
          <span>${{ getFormatAmount(cart.gstAmount) }}</span>
        </p>
      </template>
    </div>

    <div class="total" v-if="!show_subtotal_only">
      <p>
        Total <i>(incl GST)</i>
        <span>${{ getFormatAmount(cart.totalAmount) }}</span>
      </p>
    </div>

    <div class="buttons">
      <button
        class="button"
        v-if="show_proceed && cart.subTotalAmount"
        @click="goToCheckout" :disabled="disableButton"
      >
        PROCEED TO CHECKOUT
      </button>
    </div>-->

  </aside>
</template>

<script>
  export default {
    props: {
      cart: Object,
      show_proceed: Boolean,
      show_subtotal_only: Boolean
    },
    data () {
      return {
        disableButton: false,
      }
    },
    methods: {
      getFormatAmount(value) {
        let amount = parseFloat(value) //always parse and check

        return amount
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },

      goToCheckout() {
        this.disableButton = true
        window.location.href = '/checkout'
      }
    }
  }
</script>

// <style lang="scss">
// @import "../../../../sass/core/variables.scss";

// .summary {
//   float: right;
//   width: 310px;
//   // height: 280px;
//   margin: 20px 0 0 auto;

//   background: #fafbfd;

//   @media (min-width: $mediumish) {
//   }

//   h4 {
//     margin: 0;
//     padding: 20px;

//     font-size: 16px;
//     font-weight: 700;
//     line-height: 18px;
//     color: $color-4;

//     border-bottom: 1px solid #e0e6ef;
//   }

//   p {
//     margin-bottom: 9px;

//     font-size: 14px;
//     font-weight: 400;
//     letter-spacing: -0.2px;
//     line-height: 16px;

//     span {
//       font-size: 11px;
//     }

//     strong {
//       float: right;
//       font-weight: 500;
//     }
//   }

//   .costs {
//     padding: 20px 20px 11px;

//     border-bottom: 1px solid #e0e6ef;
//   }
//   .total {
//     padding: 20px;

//     p {
//       margin-bottom: 24px;
//       line-height: 29px;

//       strong {
//         font-size: 24px;
//       }
//     }

//     .button {
//       width: 100%;
//     }
//   }
// }
// </style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-cart/components/Summary.vue